import { FormControl } from '@mui/material'
import { DateTime } from 'luxon'
import React from 'react'

import { DateTimePicker, Select, TextField } from '../../../..'
import { ListFieldColumnDefinition } from '../../definitions'
import { EditFormState } from '.'

interface ConditionalFormRendererProps {
  editFormState: EditFormState
  // any because the return type of MUI onChange is any
  handleSetEditFormState: (value: any) => void
  fields: ListFieldColumnDefinition[]
}

export const ConditionalFormRenderer = ({
  editFormState,
  handleSetEditFormState,
  fields,
}: ConditionalFormRendererProps) => {
  const handleChange = (value: any, element: ListFieldColumnDefinition) => {
    handleSetEditFormState && handleSetEditFormState({ ...editFormState, [element.name]: value })
  }

  const parseFormElements = (element: ListFieldColumnDefinition) => {
    switch (element.type) {
      case 'date':
        return (
          <DateTimePicker
            key={element.name}
            label={element.label}
            value={editFormState ? DateTime.fromISO(editFormState[element.name]) : null}
            onChange={(event: DateTime | null) => handleChange(event, element)}
            views={['year', 'month', 'day']}
          />
        )
      case 'string':
        return (
          <TextField
            data-test-id={`conditional_renderer-string-${element.name}`}
            key={element.name}
            label={element.label}
            value={editFormState ? editFormState[element.name] : null}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleChange(event.target.value, element)
            }
            variant="outlined"
          />
        )
      case 'select':
        return (
          <FormControl key={element.name}>
            <Select
              data-test-id="conditional_renderer-select"
              label={element.label}
              value={editFormState ? { label: editFormState[element.name], value: editFormState[element.name] } : null}
              onChange={(value: string | string[]) => handleChange(value[0], element)}
              options={
                element?.options?.map((option: string) => ({
                  label: option,
                  value: option,
                })) || []
              }
            />
          </FormControl>
        )
      default:
        return null
    }
  }

  const parsedFormElements = fields.map((element: ListFieldColumnDefinition) => parseFormElements(element))

  return <>{parsedFormElements}</>
}
